<template>
  <div class="fixed bottom-24 right-6 flex flex-col items-center justify-center space-y-2 z-40">
    <a href="https://wa.me/84559390326" target="_blank" rel="noopener noreferrer" class="">
      <img src="../../assets/wpp-icon.svg" alt="Mandar mensagem no whatsapp" class="w-10" />
    </a>
  </div>

</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faWhatsapp)

export default {
  name: 'FloatingWhatsButton',
  components: {
    FontAwesomeIcon
  }
}
</script>